<script setup lang="ts">
import { Product } from '@/types/api/api-v3/product'

import ProductCardRatingTag from '@/components/Product/ProductCard/ProductCardRatingTag.vue'
import ProductCardTag from '@/components/Product/ProductCard/ProductCardTag.vue'

type Props = {
  product: Product
}

const props = defineProps<Props>()

const isVisibleElements = computed(() => {
  return (
    props.product?.elements && props.product.category_slug?.includes('sety')
  )
})
</script>

<template>
  <div class="image-tags">
    <product-card-rating-tag :product="product" size="sm" />

    <product-card-tag
      v-if="isVisibleElements"
      size="sm"
      background-color="var(--ui-dark-grey)"
    >
      {{ product.elements }}&nbsp;шт.
    </product-card-tag>
  </div>
</template>

<style scoped lang="scss">
.image-tags {
  position: absolute;
  top: 8px;
  left: 8px;
  z-index: 2;
  display: flex;
  gap: 4px;
  color: var(--ui-white);

  @include media('>=desktop-mini') {
    top: 12px;
    left: 16px;
  }
}
</style>
